import React from "react";
import classNames from "classnames";

const GAME_BACKGROUND_VIDEOS: Record<string, string> = {
  val: "https://static.bigbrain.gg/apps/viper.webm",
  deadlock: "https://static.bigbrain.gg/apps/deadlock_menu_streets_loop2.webm",
  lol: "https://static.bigbrain.gg/assets/lol/backgrounds/irelia_animated_bg.webm",
  wow: "https://static.bigbrain.gg/apps/wow_forever_login.webm",
};

type AccountLandingPageLayoutProps = React.PropsWithChildren<{
  game: string;
}>;

export const AccountLandingPageLayout = ({ game = "lol", children }: AccountLandingPageLayoutProps) => {
  const backgroundClassName =
    "hidden xs:block fixed desktop-app:absolute top-0 left-0 w-screen h-screen desktop-app:w-full desktop-app:h-full pointer-events-none select-none";

  const videoSrc = GAME_BACKGROUND_VIDEOS[game] ?? GAME_BACKGROUND_VIDEOS["lol"];
  const shouldDimBG = game !== "deadlock" && game !== "wow";

  return (
    <div className="relative w-full overflow-hidden desktop-app:h-full">
      <video
        autoPlay
        loop
        muted
        playsInline
        className={classNames(backgroundClassName, "object-cover object-top z-0")}
        tabIndex={-1}
        aria-hidden="true"
        src={videoSrc}
      />
      {shouldDimBG && (
        <div
          className={classNames(backgroundClassName, "z-10")}
          style={{
            background:
              "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(7,7,32,0.14) 0%, rgba(7,7,32,0.22) 40%, rgba(7,7,32,0.45) 80%, rgba(7,7,32,0.7) 100%), linear-gradient(to bottom, rgba(7,7,32,0.05) 0%, rgba(7,7,32,0.05) 85%, rgba(7,7,32,0.3) 95%, rgba(7,7,32,0.45) 100%)",
          }}
          aria-hidden="true"
          tabIndex={-1}
        />
      )}
      <div className="relative z-20 desktop-app:h-full desktop-app:overflow-x-hidden desktop-app:overflow-y-auto">
        <div className="w-full mt-[20px] xs:mt-[70px] xs:ml-[70px] flex flex-wrap gap-[20px] max-xs:justify-center">
          <div
            className="w-full rounded-[4px] max-w-[396px]"
            style={{
              background: "rgba(7, 7, 32, 0.4)",
              backdropFilter: "blur(15px)",
              WebkitBackdropFilter: "blur(15px)",
              textAlign: "left",
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

type AccountLandingPageContentProps = React.PropsWithChildren<{
  backLink?: React.ReactNode;
  header?: React.ReactNode;
}>;

export const AccountLandingPageContent = ({
  backLink,
  header = <img className="flex w-[80px]" src="https://static.bigbrain.gg/assets/ugg/logo/ugg-logo.svg" alt="U.GG" />,
  children,
}: AccountLandingPageContentProps) => (
  <div className="pt-[20px] px-[48px] pb-[48px]">
    {backLink && <div className="flex xs:mt-[8px] mb-[24px] text-[14px] text-lavender-50">{backLink}</div>}
    <div className="mb-[32px]">{header}</div>
    {children}
  </div>
);
